// store.js

import Vue from 'vue';
import Vuex from 'vuex';
import enums from './modules/enumItem';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    enums
  },
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    volunInfo: JSON.parse(localStorage.getItem('volunInfo')) || {}
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    setVolunInfo(state, volunInfo) {
      state.volunInfo = volunInfo;
      localStorage.setItem('volunInfo', JSON.stringify(volunInfo));
    }
  },
  actions: {
    login({ commit }, userInfo) {
      // 处理登录逻辑
      commit('setUserInfo', userInfo);
    },
    loginv({ commit }, volunInfo) {
      // 存志愿者信息
      commit('setVolunInfo', volunInfo);
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js